"use client";

import { useEffect } from "react";
import { useAppData } from "@/store/appStore";
import { getUserData } from "@/app/product/_actions/user.actions";
import { clientLogger } from "@/lib/logger";

const UserInitializer = ({ children }: { children: React.ReactNode }) => {
	const [, , setCookielessData] = useAppData();

	useEffect(
		() => {
			let cancelled = false;

			const fetchUser = async () => {
				try {
					// Call the server action directly
					const user = await getUserData();
					clientLogger.info("user data fetched", user);
					if (!cancelled)
						setCookielessData({ user: user || null, isUserReady: true });
				} catch (error) {
					clientLogger.error("Error fetching user data", error as Error);
					if (!cancelled) setCookielessData({ user: null, isUserReady: true });
				}
			};

			fetchUser();

			return () => {
				cancelled = true;
			};
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[],
	);

	return <>{children}</>;
};

export default UserInitializer;
